import { subAccountReportId } from '@ovComponents/4-module/widgets/portfolio/components/allocationCellKey';
import {
  type CustomAllocationReport,
  isAssetClassAllocationModel,
  storedPortfolioFraction,
} from '@ovComponents/4-module/widgets/portfolio/components/buildCustomAllocationInput';

export const getPersistedFraction = (
  portfolioReport: CustomAllocationReport,
  subAccountId: string,
  financialProductId: string,
  modelTarget: number,
) => {
  const subAccount = portfolioReport.subAccounts?.find(
    (s) => subAccountReportId(s) === subAccountId,
  );
  const holding = subAccount?.holdings?.find(
    (h) => h.financialProduct.id === financialProductId,
  );
  if (holding) {
    return (
      storedPortfolioFraction(
        holding,
        isAssetClassAllocationModel(portfolioReport),
      ) ?? modelTarget
    );
  }
  return 0;
};
